module.exports = __webpack_public_path__ + "media/left.15fbc61d.mp3";